import * as moment from 'moment';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { CalendarService } from '../../../services/calendar/calendar.service';
import { Subject } from 'rxjs';
import { EventRenderedArgs, EventSettingsModel } from '@syncfusion/ej2-angular-schedule';
import { AccountService } from 'src/app/services/account/account.service';
import { FiltersComponent } from 'src/app/filters/filters.component';
import { ActivatedRoute } from '@angular/router';
import { Filter } from 'src/app/models/filters/filters';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
})
export class CalendarComponent implements OnInit, AfterViewInit {
  account: any = this.accountService.vendor;
  isUser: boolean = localStorage.getItem('HechRomeoRole') === 'User' ? true : false;
  
  eventsSubject: Subject<void> = new Subject<void>();
  hideCalendar = false;
  totalNumber: number = 0;
  totalServices: number = 0;
  totalSearchRequest: number = 0;
  currentCurrency = null;
  eventSettings: EventSettingsModel = {
    dataSource: []
  };
  listSearchRequest = [];
  listSearchRequestShopping = [];
  listSearchRequestAdvancedShopping = [];
  services: any = [];
  eventSelected;
  reservationToModify;
  reservationToCancel = {
    reservationid: undefined,
    servicedate: undefined,
    servicetime: undefined,
    email: undefined,
    serviceid: undefined,
  };
  vendorAccount: string;
  selectedDate;
  currentLanguage = localStorage.getItem('language');

  @ViewChild('schedulerObj') schedulerObj: any;
  @ViewChild('filtersComponent') filtersComponent: FiltersComponent;

  constructor(private calendarService: CalendarService,
    private accountService: AccountService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {

    if (this.route.queryParams) {
      this.route.queryParams.subscribe((data) => {
        this.selectedDate = data['selectedDay'];
      });
    }

    this.listSearchRequest = [];
    this.listSearchRequestShopping = [];
    this.listSearchRequestAdvancedShopping = [];
    this.totalSearchRequest = 0;
    this.totalServices = 0;
    this.totalNumber = 0;
    this.eventSettings = {
      dataSource: []
    };
    
  }
  
  ngAfterViewInit() {
    this.schedulerObj.timeScale.enable = false;
    this.filtersComponent.isDetailsService = false;
    this.filtersComponent.viewDeleteReservation = false;
    this.filtersComponent.schedulerObj = this.schedulerObj;
    if (this.selectedDate) {
      let splittedDate = this.selectedDate.split('/');
      this.filtersComponent.selectedDate = new Date(splittedDate[1] + '-' + splittedDate[0] + '-' + splittedDate[2])
      this.filtersComponent.searchRequest();
    }
    this.getAccountCurrency();
  }

  reservationModalOpened(): void {
    this.eventsSubject.next();
  }

  print(): void {
    window.print();
  }

  downloadCsv(): void {
    this.calendarService.downloadCsv(this.filtersComponent.filters).subscribe((response: any) => {
      const blob = new Blob([response], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);

      if (navigator?.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, 'booked_services.csv');
      } else {
        const a = document.createElement('a');

        a.href = url;
        a.download = 'booked_services.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }

      window.URL.revokeObjectURL(url);
    });
  }

  toggleCalendar() {
    document.getElementById('calendar').style.display = this.hideCalendar ? 'none' : 'block';
    document.getElementById('minicalendar').classList.remove(!this.hideCalendar ? 'col-lg-12' : 'col-lg-4');
    document.getElementById('minicalendar').classList.add(this.hideCalendar ? 'col-lg-12' : 'col-lg-4');
  }

  onNavigateChange(event: any): void {
    if (event.currentDate) {
      this.filtersComponent.selectedDate = event.currentDate;
      console.log('this.selectedDate', this.filtersComponent.selectedDate)
    }

    this.filtersComponent.searchRequest();
  }

  onEventRendered(args: EventRenderedArgs): void {
    switch (args.data.status) {
      case 0:
        args.element.style.backgroundColor = '#efdba5';
        break;
      case 1:
        args.element.style.backgroundColor = '#cadb83';
        break;
      case 2:
        args.element.style.backgroundColor = '#ea9494';
        break;
      case 3:
        args.element.style.backgroundColor = '#94bbd6';
        break;
      case 4:
        args.element.style.backgroundColor = '#b7b7b7';
        break;
    }
  }

  onEventClick(args): void {
    if (!this.filtersComponent.isDetailsService || !this.filtersComponent.lastEvSelected || this.filtersComponent.lastEvSelected.id !== args.event.Id) {
      this.eventSelected = {
        ev: args.event.detail
      };

      switch (args.event.Subject) {
        case 'CARRELLO':
          this.getShoppingCartDetails(this.isUser ? localStorage.getItem('HechRomeoVendor') : this.account, this.eventSelected.ev, false);
          break;
        case 'CARRELLO AVANZATO':
          this.getShoppingCartDetails(this.isUser ? localStorage.getItem('HechRomeoVendor') : this.account, this.eventSelected.ev, true);
          break;
        default:
          this.getReservationDetails(this.isUser ? localStorage.getItem('HechRomeoVendor') : this.account, this.eventSelected.ev);
      }

      this.filtersComponent.lastEvSelected = this.eventSelected.ev;
      this.filtersComponent.isDetailsService = true;
    } else {
      this.filtersComponent.isDetailsService = false;
      this.filtersComponent.lastEvSelected = undefined;
      this.filtersComponent.searchRequest();
    }
  }


  getStatusOrder(orderstatus: number): string {
    if (orderstatus >= 0) {
      switch (orderstatus) {
        case 0:
          return 'In Attesa';
        case 1:
          return 'Accettata';
        case 2:
          return 'Rifiutata';
        case 3:
          return 'Processata';
        case 4:
          return 'Cancellata';
        default:
          return '';
      }
    } else {
      return '';
    }
  }

  changeReservationStatus(reservation, service, cart?): void {
    if (cart) {
      if (parseInt(reservation.status) == 4 || parseInt(reservation.orederstatus) == 4) {
        const data = {
          owner: this.accountService.vendor,
          reservationid: '',
          servicedate: reservation.reservationdate,
          servicetime: '',
          accountemail: reservation.email,
          serviceid: reservation.advancedshoppingcartid
            ? reservation.advancedshoppingcartid
            : reservation.shoppingcartid,
          ordertype: reservation.advancedshoppingcartid ? 2 : 1,
        };

        this.calendarService.cancelCart(data).subscribe(() => {
          this.filtersComponent.searchRequest();
        });
      } else {
        this.calendarService.changeStatusCart(reservation.shoppingcartid ? reservation.shoppingcartid : reservation.advancedshoppingcartid,
          this.accountService.vendor, reservation.advancedshoppingcartid
          ? parseInt(reservation.orederstatus) : parseInt(reservation.status), reservation.advancedshoppingcartid ? true : false)
          .subscribe(() => {
            this.filtersComponent.searchRequest();
          });
      }
    } else {
      if (parseInt(reservation.status) == 4) {
        this.cancelReservation(reservation.reservationid, service.servicedate, service.servicetime,
          reservation.email, service.serviceid, 0);
      } else {
        const changeStatus = {
          account: localStorage.getItem('HechRomeoAccount'),
          reservationid: reservation.reservationid,
          servicedate: service.servicedate,
          servicetime: service.servicetime,
          serviceid: service.serviceid,
          workedout: reservation.workedout,
          orederstatus: parseInt(reservation.status),
        };

        this.calendarService.changeReservationStatus(changeStatus)
          .subscribe(() => {
            this.filtersComponent.searchRequest();
          });
      }
    }
  }

  cancelReservation(reservationid, servicedate, servicetiontime, accountemail, serviceid, ordertype): void {
    this.calendarService.cancelReservation(this.isUser ? localStorage.getItem('HechRomeoVendor') : this.account, reservationid, servicedate, servicetiontime, accountemail, serviceid, ordertype,
      false, '').subscribe(() => {
        if (this.eventSelected.cart) {
          this.getShoppingCartDetails(this.isUser ? localStorage.getItem('HechRomeoVendor') : this.account, this.eventSelected.ev, false);
        } else {
          if (this.eventSelected.ev.shoppingcartdatefrom) {
            this.getShoppingCartDetails(this.isUser ? localStorage.getItem('HechRomeoVendor') : this.account, this.eventSelected.ev, true);
          } else {
            this.getReservationDetails(this.isUser ? localStorage.getItem('HechRomeoVendor') : this.account, this.eventSelected.ev);
          }
        }

        this.filtersComponent.searchRequest();
      },
        (err) => {
          console.log('cancel reservation error', err);
        }
      );
  }

  getShoppingCartDetails(account, event, advanced): void {
    this.services = {};

    const searchObj = {
      account,
      shoppingcartid: event.id,
      shoppingcartadvancedid: event.id,
    };

    if (advanced) {
      this.calendarService.getAdvancedCartDetails(searchObj)
        .subscribe((calendar) => {
          this.services = calendar;
          this.services.cart = true;
          this.totalSearchRequest = 0;
          this.totalServices = 0;
          this.totalNumber = 0;
          this.services.shoppingcartdatefrom = moment(this.services.shoppingcartdatefrom).format('DD/MM/YYYY');
          this.services.shoppingcartdateto = moment(this.services.shoppingcartdateto).format('DD/MM/YYYY');

          if (!this.filtersComponent.filters.service) {
            if (this.services.amount) {
              this.totalSearchRequest = this.totalSearchRequest + this.services.amount;
            }

            if (this.services.rateprice) {
              this.totalSearchRequest = this.totalSearchRequest + parseFloat(this.services.rateprice);
            }

            this.totalNumber += this.services.reservations.length;

            for (const item of this.services.reservations) {
              for (const slot of item.slots) {
                if (slot.quantity) {
                  this.totalServices += slot.quantity;
                } else {
                  this.totalServices += 1;
                }
              }
            }
          } else {
            for (const item of this.services.reservations) {
              if (item.serviceid === this.filtersComponent.filters.service) {
                this.totalNumber += 1;

                for (const slot of item.slots) {
                  if (slot.quantity) {
                    this.totalServices += slot.quantity;
                  } else {
                    this.totalServices += 1;
                  }

                  if (slot.amount) {
                    this.totalSearchRequest += slot.amount;
                  }
                }
              }
            }
          }
        },
          (err) => {
            console.log('calendar daily err', err);
          }
        );
    } else {
      this.calendarService.getShoppingCartDetails(searchObj)
        .subscribe((calendar) => {
          this.services = calendar;
          this.services.cart = true;
          this.totalSearchRequest = 0;
          this.totalServices = 0;
          this.totalNumber = 0;

          if (!this.filtersComponent.filters.service) {
            if (this.services.amount) {
              this.totalSearchRequest = this.totalSearchRequest + this.services.amount;
            }

            if (this.services.rateprice) {
              this.totalSearchRequest = this.totalSearchRequest + parseFloat(this.services.rateprice);
            }

            this.totalNumber += this.services.services.length;

            for (const item of this.services.services) {
              if (item.quantity) {
                this.totalServices += item.quantity;
              } else {
                this.totalServices += 1;
              }
            }
          } else {
            for (const item of this.services.services) {
              if (item.serviceid === this.filtersComponent.filters.service) {
                this.totalNumber += 1;

                if (item.quantity) {
                  this.totalServices += item.quantity;
                } else {
                  this.totalServices += 1;
                }

                if (item.amount) {
                  this.totalSearchRequest += item.amount;
                }
              }
            }
          }
        },
          (err) => {
            console.log('calendar daily err', err);
          }
        );
    }
  }

  getReservationDetails(account, event): void {
        this.services = [];

    const reservationids = [];

    for (const element of event.reservations) {
      reservationids.push(element.reservationid);
    }

    const searchObj = {
      account,
      serviceid: event.serviceid,
      reservationids: reservationids,
      servicedate: event.servicedate,
      servicetime: event.servicetime,
    };

    this.calendarService.getReservationDetails(searchObj)
      .subscribe((calendar) => {
        this.services = calendar;
        this.totalSearchRequest = 0;
        this.totalServices = 0;
        this.totalNumber = 0;

        for (const ev of this.services.reservations) {
          this.totalNumber += 1;

          if (ev.quantity) {
            this.totalServices += ev.quantity;
          } else {
            this.totalServices += 1;
          }
          
          if (ev.amount) {
            this.totalSearchRequest = this.totalSearchRequest + ev.amount;
          }

          if (ev.rateprice && ev.rateprice != "")
            this.totalSearchRequest += parseFloat(ev.rateprice);
        }
      },
        (err) => {
          console.log('calendar daily err', err);
        }
      );
  }

  searchRequest(event) {
    const listEventCalendar = [];

    this.listSearchRequest = [];
    this.listSearchRequestShopping = [];
    this.listSearchRequestAdvancedShopping = [];
    this.totalSearchRequest = 0;
    this.totalServices = 0;
    this.totalNumber = 0;
    this.filtersComponent.isDetailsService = false;

    Object.keys(event.data.days).forEach((key, index) => {
      event.data.days[key].forEach(ev => {
        if (ev.reservations.length > 0) {
          this.totalNumber += ev.reservations.length;

          for (const reservation of ev.reservations) {
            if (reservation.quantity) {
              this.totalServices += reservation.quantity;
            } else {
              this.totalServices += 1;
            }

            if (reservation.rateprice && reservation.rateprice != "")
              this.totalSearchRequest += parseFloat(reservation.rateprice);
          }
        }

        if (ev.amount) {
          this.totalSearchRequest = this.totalSearchRequest + ev.amount;
        }

        const [day, month, year] = ev.servicedate.split('/');

        // if (true) {
          // let slottext = "10:00-14:00";
          // let orariosplit = slottext.split("-");
        if (ev.reservations[0]?.slottext) {
          let orario = ev.reservations[0].slottext[0];
          let orariosplit = orario.split("-");
          const [hours, minutes] = orariosplit[0].split(':');
          const [hoursEnd, minutesEnd] = orariosplit[1].split(':');
          const [dayEnd, monthEnd, yearEnd] = ev.serviceenddate ? ev.serviceenddate.split('/') : ev.servicedate.split('/');

          const reservation = ev.reservations[0];
          const nameLabel = reservation.name ? ` - ${reservation.name}` : '';
          const lastnameLabel = reservation.lastname || '';
          const quantityLabel = reservation.quantity ? ` ( ${reservation.quantity} )` : '';

          const subject = `<div>${ev.servicename}<small> ${nameLabel} ${lastnameLabel} ${quantityLabel} </small><div>`

          listEventCalendar.push({
            Id: ev.id,
            Subject: subject,
            StartTime: new Date(+year, +month - 1, +day, +hours, +minutes),
            EndTime: new Date(+yearEnd, +monthEnd - 1, +dayEnd, +hoursEnd, +minutesEnd),
            IsAllDay: false,
            status: Math.min.apply(null, ev.reservations.map((reservation) => reservation.orederstatus)),
            detail: ev
          });
          this.listSearchRequest.push(ev);

        }else {
          const [hours, minutes] = ['9', '31'];
          const [dayEnd, monthEnd, yearEnd] = ev.serviceenddate ? ev.serviceenddate.split('/') : ev.servicedate.split('/');

          if ( ev.reservations.length ) ev.reservations.forEach( reservation => {
            const nameLabel = reservation.name ? ` - ${reservation.name}` : '';
            const lastnameLabel = reservation.lastname || '';
            const quantityLabel = reservation.quantity ? ` ( ${reservation.quantity} )` : '';
            const subject = `<div>${ev.servicename}<small> ${nameLabel} ${lastnameLabel} ${quantityLabel}</small><div>`;

            listEventCalendar.push({
              Id: ev.id,
              Subject: subject,
              StartTime: new Date(+year, +month - 1, +day, 0, 0),
              EndTime: new Date(+yearEnd, +monthEnd - 1, +dayEnd, 0, 0),
              IsAllDay: false,
              status: Math.min.apply(null, ev.reservations.map((reservation) => reservation.orederstatus)),
              detail: ev
            });
            this.listSearchRequest.push(ev);

          });
        }
      });
    });

    Object.keys(event.data.shoppingcarts.days).forEach((key) => {
      event.data.shoppingcarts.days[key].forEach((ev) => {
        if (!this.filtersComponent.filters.service) {
          if (ev.amount) {
            this.totalSearchRequest = this.totalSearchRequest + ev.amount;
          }

          this.totalNumber += ev.items.length;

          for (const item of ev.items) {
            if (item.quantity) {
              this.totalServices += item.quantity;
            } else {
              this.totalServices += 1;
            }
          }
        } else {
          for (const item of ev.items) {
            if (item.serviceid === this.filtersComponent.filters.service) {
              this.totalNumber += 1;

              if (item.quantity) {
                this.totalServices += item.quantity;
              } else {
                this.totalServices += 1;
              }

              if (item.amount) {
                this.totalSearchRequest += item.amount;
              }
            }
          }
        }

        if (ev.rateprice && ev.rateprice != "")
            this.totalSearchRequest += parseFloat(ev.rateprice);

        const [day, month, year] = ev.shoppingcartdate.split('/');
        const [hours, minutes] = ev.shoppimgcarttime.split(':');

        listEventCalendar.push({
          Id: ev.id,
          Subject: 'CARRELLO',
          StartTime: new Date(+year, +month - 1, +day, +hours, +minutes),
          EndTime: new Date(+year, +month - 1, +day, +hours + 1, +minutes),
          IsAllDay: false,
          status: ev.orederstatus,
          detail: ev
        });

        this.listSearchRequestShopping.push(ev);
      });
    });

    Object.keys(event.data.advancedshoppingcarts.days).forEach((key) => {
      event.data.advancedshoppingcarts.days[key].forEach((ev) => {
        ev.amount =
          moment(ev.shoppingcartdateto)
            .add(1, 'days')
            .diff(moment(ev.shoppingcartdatefrom), 'days') * ev.amount;

        if (!this.filtersComponent.filters.service) {
          if (ev.amount) {
            this.totalSearchRequest = this.totalSearchRequest + ev.amount;
          }

          this.totalNumber += ev.reservations.length;

          for (const item of ev.reservations) {
            for (const slot of item.slots) {
              if (slot.quantity) {
                this.totalServices += slot.quantity;
              } else {
                this.totalServices += 1;
              }
            }
          }
        } else {
          for (const item of ev.reservations) {
            if (item.serviceid === this.filtersComponent.filters.service) {
              this.totalNumber += 1;

              for (const slot of item.slots) {
                if (slot.quantity) {
                  this.totalServices += slot.quantity;
                } else {
                  this.totalServices += 1;
                }

                if (slot.amount) {
                  this.totalSearchRequest += slot.amount;
                }
              }
            }
          }
        }

        if (ev.rateprice && ev.rateprice != "")
            this.totalSearchRequest += parseFloat(ev.rateprice);

        const dateStart = moment(ev.shoppingcartdatefrom);
        const dateEnd = moment(ev.shoppingcartdateto).add(1, 'days');

        listEventCalendar.push({
          Id: ev.id,
          Subject: 'CARRELLO AVANZATO',
          StartTime: new Date(dateStart.year(), dateStart.month(), dateStart.date(), 0, 0),
          EndTime: new Date(dateEnd.year(), dateEnd.month(), dateEnd.date(), 0, 0),
          IsAllDay: true,
          status: ev.orederstatus,
          detail: ev
        });

        ev.shoppingcartdatefrom = moment(ev.shoppingcartdatefrom).format('DD/MM/YYYY');
        ev.shoppingcartdateto = moment(ev.shoppingcartdateto)
          .add(1, 'days')
          .format('DD/MM/YYYY');

        this.listSearchRequestAdvancedShopping.push(ev);
      });
    });
    this.eventSettings = {
      dataSource: listEventCalendar
    };
  }

  selectFilter() {
    this.filtersComponent.selectFilter();
    this.filtersComponent.searchRequest();
  }

  getAccountCurrency() {
    this.accountService.getAccountCurrency().subscribe((data: any) => {
      this.currentCurrency = data.currency;
    });
  }

  toFloat(value: any) {
    return parseFloat(value);
  }
}
